import { createSectionPolgonParams } from './map/polygon';
import { getSectionByOfferId } from './parsers/sections';
import { getFlatsInSectionFloor } from './parsers/flats';
export function getMVKHouseById(MVKData, houseId) {
  return MVKData.houses.find(function (h) {
    return h.id === houseId;
  });
}
var offersInfoSet = new Set();
function setOffersInfo(offers) {
  offers.forEach(function (offer) {
    if (offer.sectionNumber !== undefined) {
      offersInfoSet.add(createHashKey(offer.houseId, offer.sectionNumber, offer.flatNumber, offer.floor));
    }
  });
}
function createHashKey(houseId, sectionNumber, flatNumber, floor) {
  return "".concat(houseId, "/").concat(sectionNumber, "/").concat(flatNumber, "/").concat(floor);
}
function floorPlanValid(floorPlan, houseId, sectionNumber) {
  return !!floorPlan.floors.length && floorPlan.floors.some(function (floor) {
    return floorPlan.floorPlanFlats.some(function (floorPlanFlat) {
      return offersInfoSet.has(createHashKey(houseId, sectionNumber, floorPlanFlat.flatNumber, floor));
    });
  });
}
function sectionValid(section, houseId) {
  return section.floorPlans && section.floorPlans.some(function (floorPlan) {
    return floorPlanValid(floorPlan, houseId, section.number);
  });
}
function housesValid(houses) {
  return houses.length && houses.some(function (house) {
    return house.sections.some(function (section) {
      return sectionValid(section, house.id);
    });
  });
}

// Если в ЖК есть как минимум один полигон корпус и один поэтажный план,
// с привязанным к нему одним опубликованным объявлением.
export function MVKIsValid(MVKData) {
  setOffersInfo(MVKData.offers);
  return Boolean(MVKData.polygon && MVKData.polygon.coordinates.length && MVKData.offers.length && housesValid(MVKData.houses));
}

// возвращает стили и координаты точек для полигонов секций с поэтажным планом и объявлениями
export function getColoredSectionPolygons(MVKData, ymaps) {
  setOffersInfo(MVKData.offers);
  return MVKData.houses.reduce(function (acc, house) {
    var sections = house.sections.filter(function (section) {
      return sectionValid(section, house.id);
    }).map(function (section) {
      return createSectionPolgonParams(section, house, MVKData.offers, ymaps);
    });
    return acc.concat(sections);
  }, []);
}

// Проверяет что для объявления есть секция с поэтажным планом и полигоном на нем
export function offerIsConnectedWithFloorPlan(MVKData, offerId) {
  var offer = MVKData.offers.find(function (o) {
    return o.id === offerId;
  });
  if (!offer) {
    return false;
  }
  var section = getSectionByOfferId(MVKData, offerId);
  if (!section) {
    return false;
  }
  var offersInFloor = getFlatsInSectionFloor(MVKData, offer.houseId, section.id, offer.floor);
  return offersInFloor.some(function (o) {
    return o.id === offerId;
  });
}